import React from 'react'
import { useState, useEffect } from 'react'
import { getRequest } from '../../api/axiosRequests'
import { useNavigate } from 'react-router-dom'

export default function HomeRouter({logged, notLogged, loading}) {
  const navigate = useNavigate()
  const [isLogged, setIsLogged] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('jwt')
    if (!token || token === "" || token === "undefined" || token === null) {
      setIsLogged(false)
      setIsLoading(false)
      return
    }
    const headers = {'Authorization': token}
    const promiseUser = getRequest('userData/', headers)

    promiseUser.then(
      (res) => {
        const user = res.data['data']
        const role = res.data['role']

        // setUser(user)
        if(role === 'User' || role === 'Admin'){
          setIsLogged(true)
        }else{
          setIsLogged(false)
        }
        setIsLoading(false)
      }).catch(errs => {
      console.log(errs)
      if(errs.response){
        setIsLogged(false)
        setIsLoading(false)
      }
    })
  }, [])

    return (
      <>
      {isLoading && loading}
      {!isLoading && isLogged && navigate(logged)}
      {!isLoading && !isLogged && navigate(notLogged)}
      </>
    )
  }